import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const GetCustomerGroups = graphql(`
  query getCustomerGroups($first: Int, $after: String) {
    customerGroups(
      first: $first
      after: $after
      sort: { field: name, direction: asc }
    ) {
      __typename
      ... on CustomerGroupConnection {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            identifier
            name
          }
        }
      }
    }
  }
`);
